(function () {
  'use strict';

  /* Activation line near the bottom of the viewport — stats light as they enter, not mid-screen */
  var FOCUS_RATIO = 0.60;

  var SECTIONS = [
    {
      root: '[data-b2b-stat-grid]',
      stat: '.b2b-stat-grid__stat, .b2b-stat-grid__inline-stat',
      activeClass: 'is-active',
      boundKey: 'statGridBound',
    },
    {
      root: '[data-b2b-stat-showcase]',
      stat: '.b2b-stat-showcase__metric',
      activeClass: 'is-active',
      boundKey: 'statShowcaseBound',
    },
    {
      root: '[data-b2b-science-validation]',
      stat: '.b2b-science-validation__stat',
      activeClass: 'b2b-science-validation__stat--active',
      boundKey: 'scienceValidationBound',
    },
  ];

  function updateStatStates(stats, activeClass) {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var focusY = vh * FOCUS_RATIO;

    stats.forEach(function (stat) {
      var rect = stat.getBoundingClientRect();
      var trigger = rect.top + rect.height * 0.1;
      var scrolledPast = rect.bottom <= 0;
      var enteredView = rect.top < vh && trigger <= focusY;

      stat.classList.toggle(activeClass, scrolledPast || enteredView);
    });
  }

  function initSection(section, config) {
    if (section.dataset[config.boundKey]) return;
    section.dataset[config.boundKey] = 'true';

    var stats = Array.prototype.slice.call(section.querySelectorAll(config.stat));
    if (!stats.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      updateStatStates(stats, config.activeClass);
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    window.addEventListener('load', onScrollOrResize, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(onScrollOrResize);
      ro.observe(section);
    }
  }

  function initAll() {
    SECTIONS.forEach(function (config) {
      document.querySelectorAll(config.root).forEach(function (section) {
        initSection(section, config);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
